import React from 'react'
import AssignProductToSupermarketContainer from '../../../../Components/ProductRegisterPart/AssignProductToSupermarketContainer/AssignProductToSupermarketContainer'
import Layout from '../../Layout'

const AssignProductToSupermarket = () => {
  return (
    <Layout>
      <AssignProductToSupermarketContainer/>
    </Layout>
  )
}

export default AssignProductToSupermarket